<template>
  <v-layout v-resize="onResize" column>
    <v-data-table flat
      :headers="headers"
      :items="list"
      class="elevation-2"
      :loading="isLoad"
      :hide-headers="isMobile" :class="{mobile: isMobile}"
      click:row
    >
      <template slot="items" slot-scope="props">
        <tr v-if="!isMobile">
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ $n((setAmount(props.item.amount)), 'currency') }}</td>
          <td class="text-xs-left">{{ getKind(props.item.kind) }}</td>
          <td class="text-xs-left">{{ props.item.provider }}</td>
          <td class="text-xs-left">{{ props.item.area_code }}</td>
          <td class="text-xs-left">{{ props.item.cell_phone_number }}</td>
          <td class="text-xs-left"><v-chip small :class="`${props.item.status} white--text my-2 caption`">{{ setStatus(props.item.status) }}</v-chip></td>
          <td class="text-xs-left">{{ setDateFormat(props.item.due_date) }}</td>
          <td class="text-xs-left">
            <router-link :to="{ name: 'recharges-show', params: { id: props.item.id }}">Exibir</router-link>
          </td>
        </tr>
        <tr v-else>
          <td>
            <ul class="flex-content">
              <li class="flex-item" data-label="ID">{{ props.item.id }}</li>
              <li class="flex-item" data-label="Valor">{{  setDateFormat(props.item.created_at) }}</li>
              <li class="flex-item" data-label="Tipo">{{ getKind(props.item.kind) }}</li>
              <li class="flex-item" data-label="Operadora">{{ props.item.provider }}</li>
              <li class="flex-item" data-label="Código de Área">{{ props.item.area_code  }}</li>
              <li class="flex-item" data-label="Número do Celular">{{ props.item.cell_phone_number }}</li>
              <li class="flex-item" data-label="Status"><v-chip small :class="`${props.item.status} white--text my-2 caption`">{{ setStatus(props.item.status) }}</v-chip></li>
              <li class="flex-item" data-label="Data">{{ setDateFormat(props.item.due_date) }}</li>
              <li class="flex-item" data-label="Ações"><router-link :to="{ name: 'recharges-show', params: { id: props.item.id }}">Exibir</router-link></li>
            </ul>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { changed } from '@/helpers/layout';

export default {
  name: 'List',
  props: ['row'],
  created() {
    // Verificar se as actions existem antes de chamar
    if (this.$store._actions['recharges/list']) {
      this.$store.dispatch('recharges/list');
    } else {
      console.warn('Action recharges/list not found - recharges store may not be configured');
    }
    
    if (this.$store._actions['recharges/providers']) {
      this.$store.dispatch('recharges/providers');
    } else {
      console.warn('Action recharges/providers not found - recharges store may not be configured');
    }
    
    this.isLoading = this.isLoad;
  },
  computed: {
    ...mapGetters({
      list: 'recharges/list',
      isLoad: 'recharges/isLoad',
      providers: 'recharges/providers',
    }),
    pages() {
      return 0;
    },
  },
  components: {

  },
  watch: {

  },
  methods: {
    ...mapActions({

    }),
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `invoice ${status}`;
    },
    setAmount(amount){
      return (amount / 100)
    },
    setDateFormat(date) {
      if (date === null) {
        return ''
      } else {
        return new Date(date).toLocaleDateString("pt-BR")
      }
    },
    setStatus(status){
      if (status === "authorized") {
        return "Autorizado"
      }
      if (status === "captured") {
        return "Confirmado"
      }
      if (status === "refunded") {
        return "Cancelado"
      }
      if (status === "cancelled") {
        return "Cancelado"
      }
    },
    getKind(kind){
      if (kind === "cellphone") {
        return "Recarga de Celular"
      }
      if (kind === "pin") {
        return "Recarga de Pin"
      }
      if (kind === "tv") {
        return "Recarga de TV"
      }
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  data() {
    return {
      items: [],
      isLoading: true,
      isMobile: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Valor', value: 'amount' },
        { text: 'Tipo', value: 'kind' },
        { text: 'Operadora', value: 'provider' },
        { text: 'Código de Área', value: 'area_code' },
        { text: 'Número do Celular', value: 'cell_phone_number' },
        { text: 'Status', value: 'status' },
        { text: 'Data', value: 'due_date' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
    };
  },
};
</script>
<style>
.mobile {
      color: #333;
    }

    @media screen and (max-width: 768px) {
      .mobile table.v-table tr {
        max-width: 100%;
        position: relative;
        display: block;
      }

      .mobile table.v-table tr:nth-child(odd) {
        border-left: 6px solid #b2b2b8;
      }

      .mobile table.v-table tr:nth-child(even) {
        border-left: 6px solid #636366;
      }

      .mobile table.v-table tr td {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #f5f5f5;
        height: auto;
        padding: 10px;
      }

      .mobile table.v-table tr td ul li:before {
        content: attr(data-label);
        padding-right: .5em;
        text-align: left;
        display: block;
        color: #999;

      }
      .v-datatable__actions__select
      {
        width: 50%;
        margin: 0px;
        justify-content: flex-start;
      }
      .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: transparent;
      }

    }
    .flex-content {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 40px;
      font-weight: bold;
      margin-top: 10px;
    }
  .v-chip.invoice.false    { background-color: #B71C1C !important; }
  .v-chip.invoice.true    { background-color: #1B5E20 !important; }

  .v-chip.captured{
    background: #3cd1c2;
  }
  .v-chip.authorized{
    background: #ffaa2c;
  }
  .v-chip.refunded{
    background: #f83e70;
  }
  .v-chip.cancelled{
    background: #f83e70;
  }
</style>
